import * as s from "../../auth/signup/SignupStyled";

interface Props {}

export function SLAModal(props: Props): JSX.Element {
  return (
    <s.EULAText>
      <b>myDW Service Level Agreement</b>
      <br />
      <br />
      -----------------------------------------------------------------------------------------------
      <br />
      Affected Roles: All Users
      <br />
      Related Digital Watchdog VMS Apps: myDW Services
      <br />
      Last Edit: August 12, 2025
      <br />
      -----------------------------------------------------------------------------------------------
      <br />
      <br />
      <ol>
        <li>
          <b>
            <span className="number">1.</span> SLA Definitions
          </b>
          <ol>
            <li>
              <span className="number">1.</span> “Unavailable” and
              “Unavailability” means N consecutive error or no-response requests
              to a Cloud Service, excluding:
              <ul>
                <li>
                  <span>1.</span> Scheduled maintenance communicated within its
                  notice window
                </li>
                <li>
                  <span>2.</span> Issues caused by Reseller’s environment
                </li>
                <li>
                  <span>3.</span> Reseller equipment, domains, or credentials
                </li>
              </ul>
            </li>
            <li>
              <span className="number">2.</span> “Partially Unavailable” (or
              “Performance Degradation”) means N consecutive requests resulting
              in delayed responses (≥300% of normal latency).
            </li>
            <li>
              <span className="number">3.</span> “Incident Response Time” means
              the elapsed time from Reseller or monitoring-service Incident
              creation to Company's first substantiative communication.
            </li>
            <li>
              <span className="number">4.</span> “Incident Resolution Time”
              means the elapsed time from Incident creation to restoration of
              full service, excluding Reseller-driven delays.
            </li>
            <li>
              <span className="number">5.</span> Incident Priorities are
              assigned as follows:
              <ul>
                <li>a. Priority 1: Any P1 service Unavailability.</li>
                <li>
                  b. Priority 2: Any P2 service Unavailability or any P1 service
                  Partial Unavailability.
                </li>
                <li>
                  c. Priority 3: Any P3 service Unavailability or any P2 service
                  Partial Unavailability.
                </li>
              </ul>
            </li>
          </ol>
        </li>
        <li>
          <b>
            <span className="number">2</span> Service Commitments
          </b>
          <p>
            Provider shall use commercially reasonable efforts to meet the
            following commitments:
          </p>
          <ol>
            <li>
              <span className="number">1.</span> Cloud Services will meet the
              Availability percentages set forth in Section 3 below.
            </li>
            <li>
              <span className="number">2.</span> Upon Reseller or
              monitoring-service notification of an Incident, Company will
              deliver an initial response within the timeframes specified per
              Incident Priority in Section 3 below.
            </li>
            <li>
              <span className="number">3.</span> Company will restore service to
              an Available state within the timeframes specified per Incident
              Priority in Section 3 below.
            </li>
          </ol>
          <p>
            <br />
            If company fails to satisfy any Service Commitment, Reseller shall
            be eligible to receive Service Credits as described in Section 4 of
            this Exhibit.
          </p>
        </li>
        <li>
          <b>
            <span className="number">3</span> Service Commitments &amp; Credit
            Table
          </b>
          <table>
            <thead>
              <tr>
                <th>Category</th>
                <th>Key Performance Indicator</th>
                <th>Service Commitment</th>
                <th>Service Credit (% of Monthly Fee)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>Availability</th>
                <td>Authorization &amp; Cloud Connection (P1)</td>
                <td>≥ 99.5 % availability</td>
                <td>≤ 1 %</td>
              </tr>
              <tr>
                <td></td>
                <td>Cloud Portal (P2)</td>

                <td>≥ 99.5 % availability</td>
                <td>≤ 1 %</td>
              </tr>
              <tr>
                <td></td>
                <td>Channel Partners (P2)</td>

                <td>≥ 99.5 % availability</td>
                <td>≤ 1 %</td>
              </tr>
              <tr>
                <td></td>
                <td>Licensing (P2)</td>

                <td>≥ 99.9 % availability</td>
                <td>≤ 0.5 %</td>
              </tr>
              <tr>
                <td></td>
                <td>Emails from Cloud Portal (P2)</td>

                <td>≥ 99.5 % availability</td>
                <td>≤ 1 %</td>
              </tr>
              <tr>
                <td></td>
                <td>Push Notifications (P3)</td>
                <td>≥ 99.5 % availability</td>
                <td>≤ 1 %</td>
              </tr>
              <tr>
                <th>Incident Management Response</th>

                <td>Priority 1</td>
                <td>≤ 2 hours</td>
                <td>(See Availability Table)</td>
              </tr>
              <tr>
                <td></td>
                <td>Priority 2</td>
                <td>≤ 4 hours</td>
                <td>-</td>
              </tr>
              <tr>
                <td></td>
                <td>Priority 3</td>
                <td>≤ 12 hours</td>
                <td>-</td>
              </tr>

              <tr>
                <th>Incident Management Resolution</th>
                <td>Priority 1</td>
                <td>≤ 8 hours</td>
                <td>-</td>
              </tr>
              <tr>
                <td></td>
                <td>Priority 2</td>
                <td>≤ 24 hours</td>
                <td>-</td>
              </tr>
              <tr>
                <td></td>
                <td>Priority 3</td>
                <td>≤ 72 hours</td>
                <td>-</td>
              </tr>
            </tbody>
          </table>
          <p>
            <br />
            <b>NOTES:</b> All percentages and timeframes are calculated during
            Business Hours, excluding scheduled maintenance. Availability is
            measured per five-minute interval over each monthly billing cycle.
          </p>
        </li>
        <li>
          <b>
            <span className="number">4</span> Service Credits
          </b>
          <ol>
            <li>
              <span className="number">1.</span> Calculation: Service Credits
              are dollar-credits equal to the percentage specified in Section 3
              of the total fees for the affected monthly billing cycle, subject
              to 30% cap. Multiple breaches within one cycle yield the highest
              single Credit. Credits apply only against future payments or, at
              Provider’s discretion, the original payment method.
            </li>
            <li>
              <span className="number">2.</span> Eligibility: Credits accrue
              only if the monthly aggregate exceeds US $1.00.
            </li>
          </ol>
        </li>
        <li>
          <b>
            <span className="number">5</span> Credit Request and Payment Process
          </b>
          <p>
            To request Service Credits, Customer must submit a support ticket
            with:
          </p>
          <ol type="a">
            <li>
              <span className="number">a.</span> "SLA Credit Request" in the
              subject header
            </li>
            <li>
              <span className="number">b.</span> Documentation of each missed
              Service Commitment date/time
            </li>
            <li>
              <span className="number">c.</span> Corroborating logs or records
              (sensitive data redacted)
            </li>
          </ol>
          <p>
            <br />
            Requests must be received no later than the end of the second
            billing cycle following the missed commitment. Provider will review
            and, if approved, issue credits within one subsequent billing cycle.
          </p>
        </li>
        <li>
          <b>
            <span className="number">6</span> SLA Exclusions
          </b>
          <p>
            Provider's Service Commitments do not apply to Unavailability or
            performance issues caused by:
          </p>
          <ol type="a">
            <li>
              <span className="number">a.</span> Force majeure or Customer's
              Internet/third-party network
            </li>
            <li>
              <span className="number">b.</span> Customer's refusal of
              recommended changes or delays in approvals
            </li>
            <li>
              <span className="number">c.</span> Customer or third-party
              equipment or software
            </li>
            <li>
              <span className="number">d.</span> Provider's
              suspension/termination of Customer's Cloud access
            </li>
            <li>
              <span className="number">e.</span> Unauthorized use of Customer
              account credentials
            </li>
          </ol>
        </li>
      </ol>
    </s.EULAText>
  );
}
